
import { Options, Vue } from 'vue-class-component';
import { getError } from "@/utils/helpers";
import EventBusService from "@/services/EventBusService";
import AuthService from "@/services/AuthService";
import FieldError from "@/components/forms/FieldError.vue";
import NavigationService from "@/services/NavigationService";
import PasswordResetRequestModal from "@/components/modals/PasswordResetRequestModal.vue";

type Form = {
    email: string,
    password: string,
    remember: boolean,
};

type FormErrors = Record<string, string[]>;

@Options({
    props: {
        showRegisterLink: {
            type: Boolean,
            required: false,
            default: true,
        },
        /*preselectRegion: {
            type: Number,
            required: false,
            default: null,
        }*/
    },
    components: {
        PasswordResetRequestModal,
        FieldError,
    },
    emits: [
        'login'
    ],
})
export default class LoginForm extends Vue {
    //preselectRegion?: number|null
    loading = false
    success = false
    showRegisterLink!: boolean

    passwordResetRequestModalShown = false

    errors: FormErrors = {}

    get hasErrors() {
        return Object.keys(this.errors).length > 0;
    }

    form: Form = {
        email: '',
        password: '',
        remember: false,
    }

    submitForm() {
        this.loading = true;
        //const data = (({email, password, remember}) => ({email, password, remember}))(this.form); // create subset of object, to remove some reactive proxy stuff
        AuthService.login(this.form).then(() => {
            this.success = true;
            this.errors = {};
            this.$emit('login');
            EventBusService.$emit('user.login');
        }).catch(error => {
            //console.warn(error);
            console.warn(getError(error));
            this.errors = getError(error);
        }).finally(() => this.loading = false);
    }

    get registerUrl() {
        return NavigationService.buildRouteUrl('register');
    }

    mounted() {
        /*if( this.$store.loggedIn ) {
            NavigationService.navigateLoginSuccessful();
        }*/
    }
}
